<template>
  <div>
    <el-dialog class="replay-dialog-img" :close-on-click-modal="false" title="选择图文素材" center
      :visible.sync="dialogReply2">
      <div class="dialog-con">
        <div class="sub-title">如无你需要的素材请前往对应公众号的素材库进行上传</div>
        <el-scrollbar style="height:410px;width:100%" class="self-scroll">
          <div class="img-box">
            <div class="upload-link-img" :class="imgCurrent == index? 'choose':''" v-for="(item,index) in imgtextList"
              :key="index" @click="onChooseClick(index,item)">
              <img class="link-img" :src="item.cover_url" alt="">
              <div class='set-text-bg'>
                <p class="link-title baseEllipsis">{{item.name}}</p>
                <div class="link-text baseLineEllipsis">{{item.dec}}</div>
                <div class="date"> <span>{{item.update_time | formateDate}}</span></div>
              </div>
            </div>
          </div>
        </el-scrollbar>
        <div style="margin-top:15px">
          <el-pagination background @current-change="handleCurrentDialogChange"
            :current-page.sync="termLogParams.current" :page-size="termLogParams.size"
            layout="total, prev, pager, next, jumper" :total="termLogDataTotal">
          </el-pagination>
        </div>
        <div class="dialog-btn">
          <el-button size="small" @click="cancelClick">取消</el-button>
          <el-button size="small" type="primary" @click="onSaveClick">保存</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { formateDate } from "@/commen/date.js";
import { getMaterial } from "../api/index.js";
export default {
  props: {
    publicId: {
      type: String,
      require: true
    }
  },
  filters: {
    formateDate(time) {
      time = time * 1000;
      return formateDate(time);
    }
  },
  watch: {
    publicId(val) {
       if(val){
        this.termLogParams.current =1
         this.getMaterialData();
       }
    }
  },
  data() {
    return {
      dialogReply2: false,
      imgCurrent: null,
      imgtextList: [],
      termLogParams: {
        current: 1,
        size: 6,
        type: "news"
      },
      termLogDataTotal: 50,
      imgTextObj: null
    };
  },
  created() { 
    this.getMaterialData();
  },
  methods: {
    openDialog() {
      this.dialogReply2 = true;
    },
    cancelClick() {
      this.dialogReply2 = false;
      this.initData();
    },
    onSaveClick() {
      if (this.imgTextObj) {
        this.$emit("getImgTextObj", this.imgTextObj);
        this.dialogReply2 = false;
        this.initData();
      } else {
        this.$message.error("请选择图文素材！");
      }
    },
    initData() {
      this.imgCurrent = null;
      this.imgTextObj = null;
    },
    getMaterialData() {
      this.termLogParams.publicId = this.publicId;
      this.imgtextList = [];
      getMaterial(this.termLogParams)
        .then(res => {
          if (res.code == 0) {
            let end = res.data.records;
            end.map(item => {
              this.imgtextList.push({
                media_id: item.article_id,
                name: item.content.news_item[0].title,
                cover_url: item.content.news_item[0].thumb_url,
                update_time: item.content.update_time,
                dec: item.content.news_item[0].digest
              });
            });
            this.termLogDataTotal = res.data.total;
          }
        })
        .catch(error => {
          this.$message.error(`${error.message}`);
        });
    },
    onChooseClick(index, item) {
      this.imgCurrent = index;
      this.imgTextObj = item;
    },
    handleCurrentDialogChange(value) {
      this.termLogParams.current = value;
      this.getMaterialData();
    }
  }
};
</script>
<style >
.self-scroll .el-scrollbar__wrap,
.self-scroll .el-scrollbar__view {
  overflow-x: hidden;
}
</style>
<style scoped lang="less" scoped>
.set-text-bg {
  height: 118px;
  background: #f5f5f5;
  border-radius: 0 0 15px 15px;
}
.upload-link-img {
  width: 268px;
  height: 242px;
  position: relative;
  border: solid 4px #fff;
  border-radius: 15px;
  padding: 4px;
  color: #333;
  margin-right: 4px;
  .link-img {
    border-radius: 15px 15px 0px 0px;
    width: 100%;
    height: 110px;
    display: block;
  }
  .link-title {
    font-size: 14px;
    line-height: 14px;
    padding: 14px 16px 10px;
  }
  .link-text {
    line-height: 22px;
    margin: 0 16px 10px;
    height: 44px;
  }
  .date {
    line-height: 12px;
    margin-left: 16px;
  }
}
.dialog-btn {
  margin-top: 32px;
  /deep/.el-button {
    width: 110px;
    margin-right: 30px;
  }
}
.replay-dialog-img {
  /deep/.el-dialog {
    width: 1020px;
    height: 700px;
    border-radius: 2px;
  }
}
.sub-title {
  font-size: 14px;
  color: #999999;
}
.dialog-con {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 65px;
}
.img-box {
  display: flex;
  flex-wrap: wrap;
  margin: 48px -4px 40px 0;
  .choose {
    border-color: #1a7bfc;
  }
}
</style>